import { TESTING_UDEMY_URL, UDEMY_URL } from '@/lib/constants';
import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';
import CourseCard, { Course } from '../CourseCard';

const CoursesSection: React.FC = () => {
  const { t } = useI18n();

  const courses: Course[] = [
    {
      id: 'angular-testing-20',
      title: 'Testing en Angular 20 con Jest y Testing Library',
      description: 'Aprende a escribir pruebas unitarias efectivas en Angular moderno (v20) utilizando Jest y Testing Library. Incluye signals, componentes standalone y ejemplos reales.',
      price: 15.99,
      originalPrice: 24.99,
      discount: {
        code: 'DOMINICODE_30',
        percentage: 30,
        expiryDate: new Date('2025-09-30T23:59:59') // Fecha original de expiración
      },
      image: '/assets/img/cursos/testing-angular-20.png',
      imageAlt: 'Curso Testing en Angular 20 con Jest y Testing Library',
      ctaText: 'Acceder al curso',
      ctaUrl: TESTING_UDEMY_URL,
      ctaUrlWithCoupon: `${TESTING_UDEMY_URL}?couponCode=DOMINICODE_30`,
      isNew: true
    },
    {
      id: 'angular-moderno-20',
      title: 'Angular Moderno 20.2',
      description: 'Domina Angular Moderno (v20.2) con signals, componentes standalone, nuevo control de flujo y mejores prácticas de arquitectura.',
      price: 17.99,
      originalPrice: 24.99,
      discount: {
        code: 'DOMINICODE_30',
        percentage: 30,
        expiryDate: new Date('2025-09-30T23:59:59') // Fecha original de expiración
      },
      image: '/assets/img/cursos/angular-moderno-20.png',
      imageAlt: 'Curso Angular Moderno 20.2',
      ctaText: 'Acceder al curso',
      ctaUrl: UDEMY_URL,
      ctaUrlWithCoupon: `${UDEMY_URL}?couponCode=DOMINICODE_30`,
      isNew: true
    }
  ];

  const handleCourseClick = (course: Course) => {
    // Enviar evento de analytics si es necesario
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'click', {
        event_category: 'Course',
        event_label: course.id,
        value: course.price
      });
    }
    
    // Abrir enlace en nueva pestaña
    window.open(course.ctaUrl, '_blank', 'noopener noreferrer');
  };

  return (
    <section id="cursos" className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Título de la sección */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            {t.sections.cursosDisponibles.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t.sections.cursosDisponibles.description}
          </p>
        </div>

        {/* Grid de cursos - Responsive: 1 col móvil, 2 tablet, 3 desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {courses.map((course) => (
            <CourseCard 
              key={course.id} 
              course={course} 
              onCtaClick={handleCourseClick}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default CoursesSection;
